import React, { Component, Fragment } from 'react'
import { Button, Col, Form, Modal, Row, Select, Spin, Switch } from 'antd'
import QueueAnim from 'rc-queue-anim'
import { connect } from 'react-redux'
import axios from 'axios'
import moment from 'moment'
import { debounce } from 'lodash'

import { API_ERRO_TYPE_CANCEL } from './../../config/general'

import {
  companiesService,
  departmentsService,
  employeesService,
  journeysService,
  recalculateSchedulesService,
} from '../../redux/services'
import { DatePickerWithMask, UIFormSection, UIInfoBanner, UIPageListing, UISwitchField } from '../../components'
import { isReindexarBatidasEnabled } from '../../helpers/auth'

import ModalRecalculating from '../TimeCard/ModalRecalculating'

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isSending: false,
      progress: 0,
      nextOrder: 1,
      companies: [],
      companiesIsLoading: false,
      departments: [],
      departmentsIsLoading: [],
      employees: [],
      employeesIsLoading: false,
      journeys: [],
      journeysIsLoading: false,
      showDatesFields  : false,
      somenteInativos: false
    }

    this._axiosCancelCompaniesToken = null
    this._axiosCancelDepartmentsToken = null
    this._axiosCancelEmployeesToken = null
    this._axiosCancelJourneysToken = null
  }

  fetchCompanies = () => {
    if (this._axiosCancelCompaniesToken) {
      this._axiosCancelCompaniesToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelCompaniesToken = axios.CancelToken.source()

    this.setState({
      companiesIsLoading: true,
    })

    companiesService
      .getAutocomplete({
        orderBy: 'nome:asc',
        ativo: 1,
        cancelToken: this._axiosCancelCompaniesToken.token,
      })
      .then((response) => {
        this.setState({
          companiesIsLoading: false,
          companies: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          companiesIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartments = (value) => {
    if (this._axiosCancelDepartmentsToken) {
      this._axiosCancelDepartmentsToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelDepartmentsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // departmentsIsLoading: false,
        // departments: [],
      // })

      // return false
    // }

    this.setState({
      departmentsIsLoading: true,
    })

    let params = {
      ...(value ? { search: value } : {}),
      is_active: 1,
      orderBy: 'nome:asc',
      cancelToken: this._axiosCancelDepartmentsToken.token,
      empresas_ids: this.form.getFieldValue('empresas').includes('todos')
        ? []
        : this.form.getFieldValue('empresas'),
    }

    departmentsService
      .getAutocomplete({
        ...params,
      })
      .then((response) => {
        this.setState({
          departmentsIsLoading: false,
          departments: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          departmentsIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartmentsSearch = debounce(this.fetchDepartments, 500)

  fetchEmployees = (value) => {
    if (this._axiosCancelEmployeesToken) {
      this._axiosCancelEmployeesToken.cancel(
        'Only one request allowed at a time.'
      );
    }

    this._axiosCancelEmployeesToken = axios.CancelToken.source();

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // employeesIsLoading: false,
        // employees: [],
      // });
      // return false;
    // }

    this.setState({
      employeesIsLoading: true,
    });

    let params = {
      ...(value ? { search: value } : {}),
      ativo: 1,
      orderBy: 'nome:asc',
      cancelToken: this._axiosCancelEmployeesToken.token,
      empresas_ids: this.form.getFieldValue('empresas').includes('todos')
        ? []
        : this.form.getFieldValue('empresas'),
      departamentos_ids: this.form
        .getFieldValue('departamentos')
        .includes('todos')
        ? []
        : this.form.getFieldValue('departamentos'),
    };

    employeesService
      .getAutocomplete({
         ...params,
        })
      .then((response) => {
        this.setState({
          employeesIsLoading: false,
          employees: response.data.data,
        });
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

        this.setState({
          employeesIsLoading: false,
        });

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        });
      });
  }

  fetchEmployeesSearch = debounce(this.fetchEmployees, 500)

  fetchJourneys = (value) => {
    if (this._axiosCancelJourneysToken) {
      this._axiosCancelJourneysToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelJourneysToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // journeysIsLoading: false,
        // journeys: [],
      // })

      // return false
    // }

    this.setState({
      journeysIsLoading: true,
    })

    let params = {
      ...(value ? { search: value } : {}),
      is_active: 1,
      orderBy: 'descricao:asc',
      cancelToken: this._axiosCancelJourneysToken.token,
    }

    journeysService
      .getAll({
        ...params,
      })
      .then((response) => {
        this.setState({
          journeysIsLoading: false,
          journeys: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          journeysIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchJourneysSearch = debounce(this.fetchJourneys, 500)

  estimateTime = (numEmployees, dateRange) => {
    if (!numEmployees || !dateRange) return;
    const timeForOneEmployeeIn31Days = 5.5;
  
    const rangeDays = moment(dateRange[1]).diff(moment(dateRange[0]), 'days') + 1;
  
    const adjustedBaseTimePerEmployeePerDay = timeForOneEmployeeIn31Days / 31;
  
    const estimatedTime = numEmployees * adjustedBaseTimePerEmployeePerDay * rangeDays;
  
    return Math.ceil(estimatedTime)
  };

  startProgress = (estimatedTime) => {
    let elapsedTime = 0;

    this.setState({ progress: 0, isSending: true });

    this.progressInterval = setInterval(() => {
      elapsedTime += 1;
      const progress = Math.min((elapsedTime / estimatedTime) * 100, 99.99);
      this.setState({ progress });

      if (progress >= 99.99) {
        clearInterval(this.progressInterval);
      }
    }, 1000);
  };  

  onCompanyChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'empresas',
        value.filter((item) => item !== 'todos')
      )
    }

    this.setState({
      employees: [],
      employeesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
    });

    this.form.setFieldValue('departamentos', ['todos'])
    this.form.setFieldValue('funcionarios', ['todos']);

    this.fetchEmployees('a');
  }

  onCompanySelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('empresas', ['todos'])
    }
  }

  onDepartmentChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'departamentos',
        value.filter((item) => item !== 'todos')
      )
    }
  }

  onDepartmentSelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('departamentos', ['todos'])
    }
  }

  onEmployeeChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'funcionarios',
        value.filter((item) => item !== 'todos')
      )
    }
  }

  onEmployeeSelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('funcionarios', ['todos'])
    }
  }

  componentDidMount() {
    if (!this.state.companies.length) {
      this.fetchCompanies()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.companies !== this.state.companies && this.state.companies.length > 0) {
      this.fetchEmployees('a');
    }
  }  

  resetFields = () => {
    this.setState({
      companies: [],
      companiesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
      employees: [],
      employeesIsLoading: false,
      journeys: [],
      journeysIsLoading: false,
      showDatesFields: false,
    })
  }

  onFinish = (values) => {
    const { employees } = this.state;
    this.setState({ isSending: true });
    values.reordenar = false;

    const data = { ...values };

    if (!(data.empresas instanceof Array)) {
      data.empresas = [data.empresas]
    }

    if (!(data.departamentos instanceof Array)) {
      data.departamentos = [data.departamentos]
    }

    if (!(data.funcionarios instanceof Array)) {
      data.funcionarios = [data.funcionarios]
    }

    if (data.empresas.includes('todos')) {
      data.empresas = null
    }

    if (data.departamentos.includes('todos')) {
      data.departamentos = null
    }

    if (data.funcionarios.includes('todos')) {
      data.funcionarios = null
    }

    if (data.data_inicio) {
      data.data_inicial = moment(data.data_inicio).format('YYYY-MM-DD')
    }

    if (data.data_fim) {
      data.data_final = moment(data.data_fim).format('YYYY-MM-DD')
    }

    let numEmployees = values?.funcionarios?.length;
    if (!data.funcionarios) {
      numEmployees = employees?.length;
    }

    const dateRange = [moment(data.data_inicio).format('YYYY-MM-DD'), moment(data.data_fim).format('YYYY-MM-DD')];
    const estimatedTime = this.estimateTime(numEmployees, dateRange);
    this.startProgress(estimatedTime);

    delete data.data_inicio
    delete data.data_fim

    recalculateSchedulesService
      .create(data)
      .then((response) => {
        clearInterval(this.progressInterval);
        this.setState({ progress: 100, isSending: false });

        // Reset fields
        this.resetFields();

        Modal.success({
          content: 'Recalculo realizado com sucesso!',
          okText: 'Ok',
          onOk: () => window.location.reload(false),
        });
      })
      .catch((data) => {
        clearInterval(this.progressInterval);
        this.setState({ isSending: false, progress: 0 });

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        });
      });
  };

  onValuesChange = (changedValues) => {
    if (changedValues.hasOwnProperty('somente_inativos')) {
      this.setState({ somenteInativos: changedValues.somente_inativos });
      if (changedValues.somente_inativos) {
        this.form.setFieldsValue({ funcionarios: ['todos'] });
      }
    }
  };

  render() {
    const {
      isLoading,
      isSending,
      nextOrder,
      companies,
      companiesIsLoading,
      departments,
      departmentsIsLoading,
      employees,
      employeesIsLoading,
      journeys,
      journeysIsLoading,
      showDatesFields,
      somenteInativos,
      progress
    } = this.state

    return (
      <Fragment>
      <QueueAnim className="site-content-inner">
        <div className="page-content page-form" key="1">
          <UIPageListing
            icon={<i className="fal fa-sync-alt" />}
            title="Recalcular Horários"
            subtitle="Defina os filtros abaixo e recalcule os horários dos registros selecionados."
            enableSearch={false}
            showListTypeChange={false}
          >
            <UIInfoBanner
              icon={<i className="fal fa-info-circle" />}
              title="Sobre o Recalcular Horários"
              description="Esta ação recalcula os cartões ponto do período com base nas configurações atuais. Dias em período de cálculo fechado não são alterados. Confira os filtros antes de prosseguir."
            />
            <Form
              ref={(el) => (this.form = el)}
              layout="vertical"
              scrollToFirstError
              onFinish={this.onFinish}
              onValuesChange={this.onValuesChange}
              initialValues={{
                order: nextOrder,
                required: true,
                manter_jornada_original: false,
                reordenar: false,
                reindexar_batidas: false,
                somente_inativos: false,
                empresas: ['todos'],
                departamentos: ['todos'],
                funcionarios: ['todos'],
              }}
            >
              <UIFormSection
                icon={<i className="fal fa-filter" />}
                title="Filtros"
              >
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="empresas"
                      label="Empresa"
                      rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                      <Select
                        ref={(el) => (this.empresas = el)}
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (typeof option.children === 'string'
                            ? option.children
                            : option.children.props.children
                          )
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                        placeholder="Selecione a(s) empresa(s)"
                        notFoundContent={
                          companiesIsLoading ? (
                            <Spin
                              indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                              }
                            />
                          ) : null
                        }
                        onChange={this.onCompanyChange}
                        onSelect={this.onCompanySelect}
                        showSearch
                      >
                        <Select.Option value="todos">Todas</Select.Option>
                        {companies.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="departamentos"
                      label="Departamento"
                      rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                      <Select
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (typeof option.children === 'string'
                            ? option.children
                            : option.children.props.children
                          )
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                        placeholder="Selecione o(s) departamento(s)"
                        notFoundContent={
                          departmentsIsLoading ? (
                            <Spin
                              indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                              }
                            />
                          ) : null
                        }
                        onDropdownVisibleChange={(open) => open && this.fetchDepartments()}
                        onSearch={this.fetchDepartmentsSearch}
                        onChange={this.onDepartmentChange}
                        onSelect={this.onDepartmentSelect}
                        showSearch
                      >
                        <Select.Option value="todos">Todos</Select.Option>
                        {departments.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="funcionarios"
                      label="Funcionário"
                      rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                      <Select
                        mode="multiple"
                        filterOption={false}
                        allowClear
                        placeholder="Selecione o(s) funcionário(s)"
                        notFoundContent={
                          employeesIsLoading ? (
                            <Spin
                              indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                              }
                            />
                          ) : null
                        }
                        onDropdownVisibleChange={(open) => open && this.fetchEmployees()}
                        onSearch={this.fetchEmployeesSearch}
                        onChange={this.onEmployeeChange}
                        onSelect={this.onEmployeeSelect}
                        showSearch
                        disabled={somenteInativos}
                      >
                        <Select.Option value="todos">Todos</Select.Option>
                        {employees.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="jornada_id"
                      label="Horário"
                      tooltip="Recalcula só os dias que estão com este horário no cartão ponto."
                    >
                      <Select
                        filterOption={false}
                        allowClear
                        placeholder="Selecione o horário (jornada)"
                        notFoundContent={
                          journeysIsLoading ? (
                            <Spin
                              indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                              }
                            />
                          ) : null
                        }
                        onDropdownVisibleChange={(open) => open && this.fetchJourneys()}
                        onSearch={this.fetchJourneysSearch}
                        showSearch
                      >
                        {journeys.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.descricao}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  {!showDatesFields && (
                    <Fragment>
                      <Col xs={24} md={12}>
                        <DatePickerWithMask
                          label="Data início"
                          name="data_inicio"
                          onKeyUp={(e) => {
                            if (e.keyCode === 13 || e.keyCode === 9) {
                              this.form.data_fim.focus()
                            }
                          }}
                          required={true}
                          rules={[
                            {
                              required: true,
                              message: 'Campo obrigatório.',
                            },
                            {
                              validator: async (_, data_inicio) => {
                                var data_fim = this.form.getFieldValue('data_fim')
                                if (data_fim !== null) {
                                  if (data_inicio > data_fim) {
                                    return Promise.reject(
                                      'A data inicial deve ser menor ou igual a data final.'
                                    )
                                  }
                                }
                              },
                            },
                          ]}
                        />
                      </Col>
                      <Col xs={24} md={12}>
                        <DatePickerWithMask
                          label="Data final"
                          name="data_fim"
                          onKeyUp={(e) => {
                            if (e.keyCode === 13 || e.keyCode === 9) {
                              this.form.data_inicio.focus()
                            }
                          }}
                          required={true}
                          rules={[
                            {
                              required: true,
                              message: 'Campo obrigatório.',
                            },
                            {
                              validator: async (_, data_fim) => {
                                var data_inicio = this.form.getFieldValue('data_inicio')
                                if (data_inicio !== null) {
                                  if (data_fim < data_inicio) {
                                    return Promise.reject(
                                      'A data final deve ser maior ou igual a data inicial.'
                                    )
                                  }
                                }
                              },
                            },
                          ]}
                        />
                      </Col>
                    </Fragment>
                  )}
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={8}>
                    <UISwitchField
                      bordered
                      title="Recalcular somente inativos"
                      description="Recalcula só os funcionários inativos."
                    >
                      <Form.Item name="somente_inativos" valuePropName="checked" noStyle>
                        <Switch />
                      </Form.Item>
                    </UISwitchField>
                  </Col>
                  <Col xs={24} md={8}>
                    <UISwitchField
                      bordered
                      title="Aplicar horário do cadastro"
                      description="Atualiza os dias já calculados com o horário, o departamento e a função atuais do contrato."
                    >
                      <Form.Item name="manter_jornada_original" valuePropName="checked" noStyle>
                        <Switch />
                      </Form.Item>
                    </UISwitchField>
                  </Col>
                  {isReindexarBatidasEnabled() && (
                    <Col xs={24} md={8}>
                      <UISwitchField
                        bordered
                        title="Reindexar batidas"
                        description="Reordena as batidas em ordem cronológica quando estão fora de ordem devido à sincronização de relógios"
                      >
                        <Form.Item name="reindexar_batidas" valuePropName="checked" noStyle>
                          <Switch />
                        </Form.Item>
                      </UISwitchField>
                    </Col>
                  )}
                </Row>
                <UIInfoBanner
                  icon={<i className="fal fa-info-circle" />}
                  description="Apenas registros que atendem aos filtros acima serão recalculados."
                />
              </UIFormSection>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="recalculate-schedules-submit"
                icon={<i className="far fa-check" />}
                loading={isSending}
                disabled={isSending || isLoading}
              >
                {isSending ? 'Recalculando' : 'Recalcular horários'}
              </Button>
            </Form>
          </UIPageListing>
        </div>
      </QueueAnim>
      <ModalRecalculating
        visible={isSending}
        percent={Math.floor(progress) || 0}
        description="Estamos recalculando os horários dos registros selecionados."
        hint="Isso pode levar alguns minutos."
      />
      </Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.auth.userData.permissions,
  }
}

export default connect(mapStateToProps)(Index)
